// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/sea-land-lake-breeze.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/sea-land-lake-breeze/sea-land-lake-breeze.js';

mount([g0]);
